/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { AppContext } from '../../App';
import Legend from '../../common/Legend';
import { SeoContext } from '../../data/seo/SeoContextProvider';
import { handleCanonicalUrl } from '../../data/seo/seoUtils';
import { useAbsolutePath } from '../../data/seo/seoRouteUtils';
import ExpandedViewProvider from '../../common/ExpandedViewProvider';
import Outrights from './Outrights';
import Standings from './Standings';
import TournamentMatches from './TournamentMatches';
import BetBuilder from '../bet-builder/BetBuilder';
import BetBuilderEventsProvider from '../bet-builder/BetBuilderEventsProvider';

function Tournament(props) {
    const tournament = props.tournament;
    const appContext = React.useContext(AppContext);
    const seoContext = React.useContext(SeoContext);
    const tournamentPath = `${tournament.urlPath}${tournament.urlPathSuffix}`;
    const absoluteTournamentPath = useAbsolutePath(tournamentPath, null, tournament.urlPathSeo);

    useEffect(() => {
        if (!window.appConfig.SHOP_MODE) {
            if (window.history) {
                seoContext.refreshPathname(tournamentPath,appContext.location.current);
                handleCanonicalUrl(absoluteTournamentPath);
                //window.history.replaceState(window.history.state, null, absoluteTournamentPath);
            }
            return () => {
                //appContext.location.current === 'prematch' && window.history.replaceState(window.history.state, null, absoluteTournamentPath.substring(0, absoluteTournamentPath.indexOf([tournament.urlPath, tournament.urlPathSuffix].join(''))));
            };
        }
    }, [tournament.urlPath]);

    return (
        <>
            {function() {
                switch (props.section) {
                    default:
                    case 'matches':
                        return (
                            <ExpandedViewProvider>
                                <TournamentMatches data={props.data} />
                            </ExpandedViewProvider>
                        );
                    case 'outrights':
                        return <Outrights outrights={tournament.outrights} />
                    case 'league-table':
                        return <Standings data={tournament.classifica} sport ={tournament.sportRef} />
                    case 'bet-builder':
                        return (
                            <BetBuilderEventsProvider data={props.data} tournament={tournament}>
                                <BetBuilder />
                            </BetBuilderEventsProvider>
                        );
                }
            }()}
            <Legend />
        </>
    );
}

export default Tournament;